import { useState } from "preact/hooks";
import { convertDateTimeThailand } from "../../../functions";
import { useMessage } from "../../../hooks/useMessage";
import { GET_DEVICES_LOT, POST } from "../../../services/index";
import { IRecord } from "../interfaces/state";

export const useSearchData = () => {
  const [data, setData] = useState([] as IRecord[]);
  const { openMessage } = useMessage();
  const onSearch = async (lot_id: string | null) => {
    try {
      const object = { lot_id };
      const res = await POST(GET_DEVICES_LOT, object);
      const { devices } = res.result;
      const newData: IRecord[] = devices.map((e: IRecord, i: number) => ({
        ...e,
        index: i + 1,
        key: e.deviceID,
        qcDate: e.qcDate ? convertDateTimeThailand(e.qcDate) : null,
      }));
      setData(newData);
      if (devices.length === 0) {
        openMessage("error", "ไม่พบข้อมูล");
      }
      if (devices.length > 0) {
        openMessage("success", res.message);
      }
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.message);
    }
  };

  const onClearForm = () => {
    setData([]);
  };

  return {
    data,
    setData,
    onSearch,
    onClearForm,
  };
};
